import { useMutation } from '@tanstack/react-query';
import { createSplitPayment } from '../../services/payments';
import { CreateSplitPaymentPayload } from '../../types/payments';

interface Props {
  onSuccess?: (data: Awaited<ReturnType<typeof createSplitPayment>>) => void;
  onError?: (error: Error) => void;
}

function useCreateSplitPayment({ onSuccess, onError }: Props = {}) {
  return useMutation({
    mutationFn: ({
      splitPaymentsGroupId,
      payload,
    }: {
      splitPaymentsGroupId: string;
      payload: CreateSplitPaymentPayload;
    }) => createSplitPayment(splitPaymentsGroupId, payload),
    onSuccess,
    onError,
  });
}

export default useCreateSplitPayment;
